import './popup.scss';

class Popup{

    constructor( id ) {
        this.id = id;
        this.popup = undefined;
        this.content = undefined;
        this.overlay = undefined;
        this.closeButton = undefined;
        this.template = `
            <div class="popup-overlay"></div>
            <div class="popup-content"></div>
            <i class="popup-close"></i>`;
        this.init();
    }

    init = () => {
        this.popup = document.getElementById(this.id);

        if(!this.popup){
            this.popup = document.createElement('div');
            this.popup.id = this.id;
            this.popup.innerHTML = this.template;
            document.body.appendChild(this.popup);
        }

        this.overlay = this.popup.querySelector('.popup-overlay');
        this.content = this.popup.querySelector('.popup-content');
        this.closeButton = this.popup.querySelector('.popup-close');

        this.overlay.addEventListener('click',this.close);
        this.closeButton.addEventListener('click',this.close);


        // console.log(`Popup : #${this.id} initialized`);
    }


    open = (content) => {
        this.content.innerHTML = content;
        this.popup.classList.add('open');
        document.body.classList.add(`popup-open`);
    }

    close = () => {
        this.content.innerHTML = '';
        this.popup.classList.remove('open');
        document.body.classList.remove(`popup-open`);
    }

}

export default Popup;